import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import Ad from '../ad/ad';
import { PostHero, PostShort, PostVideo, PostDefault } from './layouts';
import { isAdvertorial } from '../advertorial/advertorial';
import pressboard from '../../../client/utils/third_party_trackers/pressboard';

export default class PostsContainer extends Component {
  componentWillMount() {
    if (
      this.props.updateCorrelator &&
      canUseDOM &&
      window.googletag &&
      window.googletag.pubadsReady
    ) {
      window.googletag.pubads().updateCorrelator();
    }
  }

  componentDidMount() {
    this.rendered = true;
    this.renderTrackers();
  }

  shouldComponentUpdate() {
    const { props, rendered } = this;
    // initialPageLoad is needed for the first post to enable sticky ads.
    const isInitLoad = get(props, 'config.initialPageLoad');

    return !rendered || isInitLoad;
  }

  renderTrackers() {
    const postId = get(this.props.posts, '[0].id', 0);
    if (postId === 40504669 || postId === 40537786) {
      pressboard();
    }
  }

  renderTrackerField() {
    const { posts } = this.props;

    const customScriptData = get(posts, '[0].customFields.custom_script');
    const customScriptExpiration = get(posts, '[0].customFields.expiration');

    if (customScriptData && customScriptExpiration === false) {
      return <div dangerouslySetInnerHTML={{ __html: customScriptData }} />;
    }
    return '';
  }

  renderTopAds(firstPost) {
    const { isFirstPost, combinedAdModel, pageNum } = this.props;
    combinedAdModel.readTime = get(firstPost, 'readTime');
    combinedAdModel.pageNum = pageNum;
    const adName = isFirstPost ? 'flexiblepushdown' : 'flexiblebillboard';
    const region = isFirstPost ? 'articletop' : 'articlescroll';

    return (
      <div className="post__article-top-ad-wrapper">
        <Ad {...combinedAdModel} name={adName} region={region} />
        <Ad {...combinedAdModel} name="mobileleaderboard" region={region} />
      </div>
    );
  }

  renderTemplate(firstPost, advertorial) {
    const type = firstPost.layout;

    // STYLE GUIDE POST: /pvw/40400521/style-guide-for-fast-company-posts-in-2017
    switch (type) {
      // Poster: 3021050/leadership-lessons-from-the-us-army-in-afghanistan
      // Slideshow:
      // Video:
      case 'hero':
        return <PostHero {...this.props} advertorial={advertorial} />;
      // 40538300/facebook-comes-to-the-realization-that-one-feed-is-better-than-two
      case 'short':
        return <PostShort {...this.props} advertorial={advertorial} />;
      // video/your-jean-jacket-of-the-future-could-be-made-using-3d-printing-tech/cc5Qb4Nr
      case 'video':
        return <PostVideo {...this.props} advertorial={advertorial} />;
      // Poster: 40525480/the-marvel-studios-mind-set-for-making-hit-after-hit
      // Slideshow: 40537294/the-25-best-productivity-apps-for-2018
      default:
        return <PostDefault {...this.props} advertorial={advertorial} />;
    }
  }

  render() {
    const { posts, combinedAdModel } = this.props;
    const firstPost = get(posts, '[0]');
    const advertorial = isAdvertorial(get(firstPost, 'tags', []));
    const modifier = advertorial ? 'post__wrapper--advertorial' : '';

    if (!firstPost) return null;

    return (
      <div className={`post__wrapper ${modifier}`}>
        {this.renderTopAds(firstPost)}
        <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />
        {this.renderTemplate(firstPost, advertorial)}
        {this.renderTrackerField()}
      </div>
    );
  }
}

PostsContainer.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

PostsContainer.propTypes = {
  config: PropTypes.shape({}).isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  isFirstPost: PropTypes.bool,
  videoAdData: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.number.isRequired,
  updateCorrelator: PropTypes.bool,
  live: PropTypes.bool
};
